import { openPopup } from '../functions/popups'; 

export const newsletter = () => {
    const footerTrigger = document.querySelector('.js-newsletter-trigger');

    if ( footerTrigger ) {
        footerTrigger.addEventListener('click', (event) => {
            event.preventDefault();
            
            const emailAddress = footerTrigger.previousElementSibling.value;
            const signupEmailField = document.querySelector('.js-newsletter-email');

            if ( signupEmailField ) {
                signupEmailField.value = emailAddress;
            }

            openPopup('#newsletter');
        });
    }
}